import React from "react";
import logo from "../assets/images/logo.png"; // adjust path if needed

export default function PageLoader() {
  return (
    <div className="page-loader">
      <div className="loader-inner">
        <img src={logo} alt="BrightLife Physio Point" className="loader-logo" />
        <div className="loader-line" />
      </div>
    </div>
  );
}
